import { render, staticRenderFns } from "./admin-setup-demo.vue?vue&type=template&id=f9850cc0&scoped=true&"
import script from "./admin-setup-demo.vue?vue&type=script&lang=js&"
export * from "./admin-setup-demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9850cc0",
  null
  
)

export default component.exports